export default __webpack_public_path__ + "static/Moodboard-589016d1d4fc9f044a40c7dab47c1329.png";